import { prepareDocForUpdate } from './helpers/firestoreHelpers'

const updateGuideDraft = (draftRef, values) => {
  
  return draftRef
    .set(prepareDocForUpdate(values), {merge: true})
}

export default updateGuideDraft
